/** @file Animations panel rows: every animation by name with its length in frames. */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, Id } from '@pose2d/format/types';
import { animationFrames } from '../../playback/animationFrames';

/** One listed animation. */
export interface AnimationRowData {
  id: Id;
  name: string;
  frames: number;
}

/** Canonical order: by name in code-unit order (`run` before `run@SE` before `walk`). */
export function animationRows(doc: Doc): AnimationRowData[] {
  return entriesByName(doc.animations).map(([id, anim]) => ({ id, name: anim.name, frames: animationFrames(anim) }));
}
